import { clientApi } from 'shared/api/clientApi.ts'
import { Response } from 'shared/models/general.ts'

import type { RawTourFlight } from './model'

export const TourFlights = {
  getFlights: (tourId: string, operator?: string) => {
    return clientApi.get<Response<RawTourFlight>>('/tours/hotels/flights', {
      params: {
        tour_id: tourId,
        operator,
      },
    })
  },
}
